namespace GeniuzPOS.Administration {
    export namespace PsFuncKbMapKeyCodeService {
        export const baseUrl = 'Administration/PsFuncKbMapKeyCode';

        export declare function Create(request: Serenity.SaveRequest<PsFuncKbMapKeyCodeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsFuncKbMapKeyCodeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsFuncKbMapKeyCodeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsFuncKbMapKeyCodeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/PsFuncKbMapKeyCode/Create",
            Update = "Administration/PsFuncKbMapKeyCode/Update",
            Delete = "Administration/PsFuncKbMapKeyCode/Delete",
            Retrieve = "Administration/PsFuncKbMapKeyCode/Retrieve",
            List = "Administration/PsFuncKbMapKeyCode/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsFuncKbMapKeyCodeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
